import React, { useContext, useState, useCallback } from "react";
import toast from 'react-hot-toast';
import { addDoc, collection, Timestamp } from "firebase/firestore";
import { useNavigate } from "react-router-dom";

import MainLayout from '../layouts/MainLayout'
import UserInfos from '../components/UserInfos'
import { AuthContext } from '../services/Session/Context'
import { FirebaseContext } from '../services/Firebase/Context'
import LoadableButton from "../components/LoadableButton"


const TrainingCreate = () => {
  const [loading, setLoading] = useState(false)
  const { db } = useContext(FirebaseContext) || {}
  const { user } = useContext(AuthContext)
  const navigate = useNavigate()

  const handleSubmit = useCallback(async e => {
    e.preventDefault()
    if(!user || !db) {
      return
    }
    setLoading(true)
    const { name, reference, goal } = e.target.elements
    if(!name.value || !reference.value || !goal.value) {
      toast.error('Veuillez remplir tous les champs !')
      setLoading(false)
      return
    }
    const record = {
      name: name.value,
      reference: reference.value,
      goal: goal.value,
      organisationId: user.organisationId,
      userId: user.uid,
      createdAt: Timestamp.now()
    }
    addDoc(collection(db, "training"), record)
    .then((d) => {
      toast.success('Nouvelle formation créée !')
      setLoading(false)
      navigate(`/training/${d.id}`)
    })
    .catch(() => {
      setLoading(false)
      toast.error('Erreur veuillez reessayer');
    });
  }, [user, db, navigate])

  return (
    <MainLayout>
      <div className="flex">
        <div className="flex-1">
          <h1 className="text-4xl font-semibold text-gray-800">Création d'une formation</h1>
          <h2 className=" text-gray-400">Vous pourrez par la suite compléter ou modifier les informations</h2>
        </div>
        <UserInfos/>
      </div>
      <form className="mt-5 container mx-auto max-w-2xl md:w-3/4 bg-white shadow-md rounded-lg" onSubmit={handleSubmit}>
        <div className="space-y-6 text-gray-500 p-5">
          <label className="block">
            <span className="text-gray-700 font-medium">
              Intitulé de la formation
              <span className="ml-1 text-red-500 required-dot">*</span>
            </span>
            <input type="text" name="name" className="
                mt-1
                block
                w-full
                rounded-md
                border-gray-300
                shadow-sm
                focus:border-purple-300 focus:ring focus:ring-purple-200 focus:ring-opacity-50
              " placeholder="" />
          </label>
          <label className="block">
            <span className="text-gray-700 font-medium">
              Référence
              <span className="ml-1 text-red-500 required-dot">*</span>
            </span>
            <input type="text" name="reference" className="
                mt-1
                block
                w-full
                rounded-md
                border-gray-300
                shadow-sm
                focus:border-purple-300 focus:ring focus:ring-purple-200 focus:ring-opacity-50
              " placeholder="" />
          </label>
          <label className="block">
            <span className="text-gray-700 font-medium">
              Objectif
              <span className="ml-1 text-red-500 required-dot">*</span>
            </span>
            <textarea className="
              mt-1
              block
              w-full
              rounded-md
              border-gray-300
              shadow-sm
              focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50
            " rows={3} name="goal"/>
          </label>
          <div className="flex justify-center">
            <div className="w-1/4">
              <LoadableButton title={loading ? 'Enregistrement...' : "Commencer"} isSubmit loading={loading} />
            </div>
          </div>
        </div>
      </form>
    </MainLayout>
  ) 
}

export default TrainingCreate